// extracted by mini-css-extract-plugin
export default {"navButton":"src-common-components-settings-navigation-tabs-settings-navigation-tabs-module__navButton--2WLtv"};